import { api } from "@/services/api";

export type BannerVariant = "info" | "error" | "warning" | "success";

export interface BroadcastBanner {
  id: string;
  variant: BannerVariant;
  title: string;
  body?: string | null;
  inline: boolean;
  is_active: boolean;
  updated_at: string;
}

export interface BroadcastBannerSet {
  variant: BannerVariant;
  title: string;
  body?: string;
  inline?: boolean;
}

export const broadcastApi = {
  get: () => api.get<BroadcastBanner | null>("/api/broadcast"),
  set: (data: BroadcastBannerSet) => api.put<BroadcastBanner>("/api/admin/broadcast", data),
  hide: () => api.delete<void>("/api/admin/broadcast"),
};
